export const RAM_TYPE = [
  { id: 0, name: 'None' },
  { id: 1, name: '1 GB' },
  { id: 2, name: '2 GB' },
  { id: 3, name: '3 GB' },
  { id: 4, name: '4 GB' },
  { id: 5, name: '5 GB' },
  { id: 6, name: '6 GB' },
  { id: 7, name: '7 GB' },
  { id: 8, name: '8 GB' },
  { id: 9, name: '9 GB' },
  { id: 10, name: '10 GB' },
  { id: 11, name: '11 GB' },
  { id: 12, name: '12 GB' },
  { id: 13, name: '13 GB' },
  { id: 14, name: '14 GB' },
  { id: 15, name: '15 GB' },
  { id: 16, name: '16 GB' },
  { id: 17, name: '17 GB' },
  { id: 18, name: '18 GB' },
  { id: 19, name: '19 GB' },
  { id: 20, name: '20 GB' },
  { id: 21, name: '21 GB' },
  { id: 22, name: '22 GB' },
  { id: 23, name: '23 GB' },
  { id: 24, name: '24 GB' },
];

export const STORAGE_TYPE = [
  { id: 0, name: 'None' },
  { id: 1, name: '16 GB' },
  { id: 2, name: '32 GB' },
  { id: 3, name: '64 GB' },
  { id: 4, name: '128 GB' },
  { id: 5, name: '256 GB' },
  { id: 6, name: '512 GB' },
  { id: 7, name: '1 TB' },
  { id: 8, name: '2 TB' },
];